import state from './moduleM0CheckListReportState.js'
import mutations from './moduleM0CheckListReportMutations.js'
import actions from './moduleM0CheckListReportActions.js'
import getters from './moduleM0CheckListReportGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}